// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__qmhOC","window":"styles_window__-x7uF","wrapper":"styles_wrapper__EYmOY","title":"styles_title__AV4RK","buttons":"styles_buttons__FBymp"};